import { useState } from 'react'

import { ClosingAgreementRequirementsModel } from '@user/store/closingRequirements/typings'
import { useGetExternalProductFriendlyName } from '@user/store/authorization/hooks/useGetExternalProductFriendlyName'

export function useData(model: ClosingAgreementRequirementsModel) {
  const [disabled, setDisabled] = useState(!model.requireAgreement)
  const [disableAutoClose, setDisableAutoClose] = useState(
    !model.requireCustomerSignature,
  )
  const [requirement, setRequirement] =
    useState<ClosingAgreementRequirementsModel>({ ...model })

  const externalProductName = useGetExternalProductFriendlyName()
  const autoCloseWinTitle = `Auto-close/win opportunities when agreement is completed by customer (${externalProductName} location and closing requirements still apply). Opportunities automatically closed/won in this sales funnel will be submitted to the Closed Won Queue.`
  const autoCloseWinLeadsTitle = `Auto-close/win leads when agreement is completed by customer (${externalProductName} location and closing requirements still apply). Leads automatically closed/won in this sales funnel will be submitted to the Closed Won Queue.`

  return {
    disabled,
    setDisabled,
    disableAutoClose,
    setDisableAutoClose,
    requirement,
    setRequirement,
    autoCloseWinTitle,
    autoCloseWinLeadsTitle,
  }
}

export type UseData = ReturnType<typeof useData>
